<template>
	<div><span class="biaoti">自定义菜单</span>
		<el-form  label-width="80px">
			<el-card class="box-card" body-style="padding:0;">
				<el-form-item label="菜单编辑器" class="touu" label-width="100px"></el-form-item>
				<el-form-item class="bg" v-for="(yiji,yijiindex) in caidanlie" :key="yijiindex">
					<el-input v-model="yiji.name" size="small" style="width: 220px;margin-left: -40px;" placeholder="菜单名称"></el-input>
					<el-link :underline="false" class="el-icon-edit dian" type="info" style="margin-left: 10px;" @click="dakaishezhi(yijiindex)">设置链接</el-link>
					<el-link :underline="false" class="el-icon-close dian" type="info" @click="shanchu(yijiindex)">删除菜单</el-link>
					<el-link :underline="false" type="info" class="el-icon-plus dian" @click='tianjia(yiji)' >添加子菜单</el-link>
					<div class="bg erji" v-for="(erji,erjiindex) in yiji.sub_button" >
						<el-input v-model="erji.name" size="small" style="width: 220px;margin-left: -40px;" placeholder="菜单名称"></el-input>
						<el-link :underline="false" class="el-icon-edit dian" type="info" style="margin-left: 10px;"  @click="dakaishezhi(yijiindex,erjiindex)">设置链接</el-link>
						<el-link :underline="false" class="el-icon-close dian" type="info" @click="shanchu(yijiindex,erjiindex)">删除菜单</el-link>
					</div>
				</el-form-item>
				<el-form-item class="" style="">
					<el-button type="info" size="small" style="margin-left: -60px;" @click="tianjia()">添加菜单</el-button>
					<span style="color:#788188; margin-left: 20px;"> 最多只能添加三个主菜单，每个子菜单下可添加5个子菜单</span>
				</el-form-item>
			</el-card>
			<el-form-item>
				<el-button type="danger" @click="onSubmit" size="small" style="margin-left: -80px;margin-top: 20px;">保存菜单结构</el-button>
			</el-form-item>
		</el-form>
		<!-- 设置链接弹框 -->
		<el-dialog title="选择菜单要执行的操作" :visible="lianJie" :before-close="handleClose">
			<el-divider></el-divider>
			<el-form >
				<el-form-item >
					<el-radio-group v-model="neirong.type">
						<el-radio label="view">链接</el-radio>
						<el-radio label="click">触发关键字</el-radio>
						<el-radio label="scancode_push">扫码</el-radio>
						<el-radio label="miniprogram">小程序</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="" label-width="10" style="">
					<el-input v-model="neirong.url">
						<el-button slot="append" icon="el-icon-share">链接</el-button>
					</el-input>
					<!-- <el-button type="primary"> <i class="" style="color: #FFFFFF;"></i></el-button> -->
					<span class="tishi">指定点击此菜单时要跳转的链接（注：链接需加http://）</span>
					<div class="tishi h3">注意: 由于接口限制. 如果你没有网页oAuth接口权限.</div>

				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="shezhi()" size="small">保 存</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	let that;
	export default {
		data() {
			return {
				neirong: {},
				caidanlie: [],
				lianJie: false,
				yijiindex:'',erjiindex:''
			}
		},
		created() {
			that = this;
			this.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=weixincaidan', function(s) {
					if(s.shu){
						that.caidanlie=s.shu
					}
						
				});
			},
			onSubmit() {
				this.$post('k=weixincaidan',{c:'xiugai',button:this.caidanlie}, function(s) {
					  that.$xiaoxi(s.shu);
				});
			},
			shanchu(yiji,erji) {
				if(yiji>=0 && erji>=0){
					this.caidanlie[yiji].sub_button.splice(erji, 1)
				}else{
					this.caidanlie.splice(yiji, 1)
				}
				this.$set(this.caidanlie,yiji,this.caidanlie[yiji]);
			},
			tianjia(e) {
				if(e){				
					if (!e.sub_button) {
						this.$set(e, 'sub_button', []);
					}
					if(e.sub_button.length>=5){
							that.$xiaoxi('二级菜单最多5个');
							return false;
					}
					e.sub_button.push({type:"view",name:""});		
					
				}else{
					if(this.caidanlie && this.caidanlie.length>=3){
						  that.$xiaoxi('一级菜单最多3个');
						  return false;
					}
					this.caidanlie.push({
						"type": "view",
						"name": "",
					});
				}
			},
			dakaishezhi(yiji,erji) {
				this.lianJie = true;
				this.yijiindex=yiji;
				this.erjiindex=erji;
				if(yiji>=0 && erji>=0){
					this.neirong=this.caidanlie[yiji].sub_button[erji];
				}else{
					this.neirong=this.caidanlie[yiji];
				}
			},
			shezhi(){
				if(this.yijiindex>=0 && this.erjiindex>=0){
					this.$set(this.caidanlie[this.yijiindex].sub_button,this.erjiindex,this.neirong);
				}else{
					this.$set(this.caidanlie,this.yijiindex,this.neirong);
				}
				this.lianJie = false;
				this.yijiindex='';
				this.erjiindex='';
			},
			handleClose(done) {
				this.lianJie = false;
				this.yijiindex='';
				this.erjiindex='';
			},
		}
	}
</script>

<style>
	.erji{
		margin-left: 30px;
	}
	
	
	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.touu {
		background: #f7fafa;
		border: 1px solid #eaeef1;
	}

	.bg {
		background: #ffffff;
	}

	.dian {
		padding: 2px 8px;
	}

	.dian:not(:last-child) {
		border-right: 1px solid #e1e1e1;
	}

	.el-dialog__body {
		padding: 0px 20px;
	}

	.el-form-item__content {
		/* display: flex; */
		/* width: 100%; */
	}

	.tishi {}

	.h3 {
		font-size: 16px;
		margin-top: 10px;
		font-weight: bold;
	}
</style>
